





























import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import {
  FailureDisclaimer,
  FailureReport,
  FailuresRootCause
} from "@dsm/dsm-storybook";
import {
  disclaimer,
  reportIntroductionInfo,
  rootCausesInformation
} from "@/service/initial-data";
import {ReportData} from "@/interfaces/questions";

@Component({
  components: {
    FailureDisclaimer,
    FailureReport,
    FailuresRootCause
  }
})
export default class Report extends Vue {
  @Prop({ type: Array(Object) })
  rootCauses!: Array<ReportData> | null;

  @Prop()
  riskData!: number[];

  disclaimerInformation = disclaimer;
  reportInfo = reportIntroductionInfo;
  rootCausesBaseInformation = rootCausesInformation;

  convertRiskDataToColorIndex(risk: number) {
    switch (true) {
      case (risk <= 25):
        return 0;
      case ( 26 <= risk && risk <= 51 ):
        return 1;
      case (51 <= risk && risk <= 75 ):
        return 2;
      case (76 <= risk && risk <= 100 ):
        return 3;
      case (101 <= risk && risk <= 125 ):
        return 4;
      default:
        return -1;
    }
  }

  resetToQuestion(questionIndex: number) {
    this.$emit('resetToQuestion', questionIndex);
  }
}
